<template>
  <page-content :show-search="true">
    <template #search>
      <table-search
        ref="search"
        :fields="search_fields"
        @runSearch="runSearch"
      />
    </template>

    <template #default>
      <table-header
        ref="header"
        :title="title"
        :button-actions="header_actions"
        @runSearch="runSearch"
        :search-tips="$t('facility.search_tips')"
      />

      <table-content
        :per-page="page_condition.pageSize"
        :per-page-dropdown-enabled="true"
        @perPageChange="perPageChange"
        :columns="columns"
        :rows="rows"
        :total-rows="total_rows"
        :current-page="current_page"
        :action-options="table_actions"
        @runTableAction="runTableAction"
        @sortChange="sortChange"
        @pageChange="pageChange"
        :permission="view_permission"
      />
    </template>

  </page-content>
</template>

<script>
import common from "@/common";
import TableContent from "@/components/TableContent";
import TableHeader from "@/components/TableHeader";
import TableSearch from "@/components/TableSearch";
import PageContent from "@/components/PageContent";

export default {
  name: 'facility',
  components: {
    PageContent,
    TableSearch,
    TableHeader,
    TableContent,
  },
  data() {
    return {
      title: common.getMenuName('facility'),
      view_permission: common.checkPermission('Fac_List'),
      rows: [],
      total_rows: 0,
      sort_condition: {},
      current_page: 1,
      page_condition: {
        pageIndex: 0,
        pageSize: common.getTablePerPage()
      },
      columns: [
        {
          label: 'common.row_index',
          field: 'row_index',
          sortable: false,
          width: '50px',
        },
        {
          label: 'facility.facilityCode',
          field: 'facilityCode',
        },
        {
          label: 'facility.chineseName',
          field: 'chineseName',
        },
        {
          label: 'facility.englishName',
          field: 'englishName',
        },
        {
          label: 'facility.memberQuota',
          field: 'memberQuota',
          change: num => String(num)
        },
        {
          label: 'facility.contractEndDay',
          field: 'contractEndDay',
          width: '120px',
          formatFn: (v) => v ? this.$moment(v).format('YYYY-MM-DD') : '',
          changeHTML: (v, row) => {
            let content = `<div>${v}</div>`
            if (row.contractStatus === 'ThreeMonthRemained') content = `<div class="text-orange">${v}</div>`
            if (row.contractStatus === 'OneMonthRemained') content = `<div class="text-red">${v}</div>`
            if (row.contractStatus === 'Expired') content = `<div class="text-gray">${v}</div>`

            const daysRemain = row.contractCountDownDay
            if ([null, undefined].includes(daysRemain)) return content

            if (daysRemain >= 0) content += `<div class="text-sub">剩餘 ${daysRemain} 天</div>`
            if (daysRemain < 0) content += `<div class="text-sub">已到期</div>`
            return content
          },
        },
        {
          label: 'common.action',
          field: 'action',
          width: '200px',
          sortable: false,
        },
      ],
      header_actions: [
        {
          text: 'common.add',
          variant: 'primary',
          fun: this.addData,
          permission: 'Fac_Create'
        },
      ],
      table_actions: [
        {
          text: 'common.edit',
          variant: 'primary',
          fun: 'editData',
          permission: 'Fac_View'
        },
        {
          text: 'common.delete',
          variant: 'danger',
          fun: 'deleteData',
          permission: 'Fac_Delete'
        }
      ],
      search_fields: [
        {
          field: 'contract',
          label: 'facility.search_contract',
          type: 'select',
          options: [
            { text: this.$t('facility.search_contract_expired'), value: 0 },
            { text: this.$t('facility.search_contract_one_month'), value: 1 },
            { text: this.$t('facility.search_contract_three_month'), value: 2 },
          ]
        },

      ]
    }
  },
  mounted() {
    this.getList()
  },

  methods: {
    getList: function () {
      if (!this.view_permission) return

      const api = '/facility/GetFacilityList'
      const search = this.getSearchCondition()

      const url = common.getTableUrl(api, search, this.sort_condition, this.page_condition)

      common.apiGetData(url).then(res => {
        this.total_rows = res.data.total
        this.rows = res.data.facilitys
      })
    },
    perPageChange(size) {
      this.page_condition.pageIndex = 0
      this.page_condition.pageSize = size
      common.setTablePerPage(size)
      this.getList()
    },
    addData: function () {
      this.$router.push({ name: 'facility_add' })
    },
    editData: function (data) {
      this.$router.push({ name: 'facility_edit', params: { id: common.encrypt(data.facilityID) } })
    },
    deleteData: function (data) {
      const that = this
      common.showConfirm(this.$t('common.delete_tips') + data.chineseName, '', function () {
        common.apiPostData('/facility/DeleteFacility?facilityID=' + data.facilityID).then(res => {
          common.showToast(that.$t('common.delete_success'))
          that.getList()
        })

      })
    },
    runSearch: function () {
      this.current_page = 1
      this.page_condition.pageIndex = 0
      this.getList()
    },
    runTableAction: function (action, data) {
      this[action](data)
    },
    sortChange: function (value) {
      this.sort_condition = value
      this.getList()
    },
    getSearchCondition: function () {
      this.$refs.search.buildSearchCondition()

      let where = {}
      where['searchContent'] = this.$refs.header.searchContent
      where = Object.assign(where, this.$refs.search.search_condition)

      return where
    },
    pageChange: function (value) {
      this.current_page = value
      this.page_condition.pageIndex = value - 1
      this.getList()
    },
  }
}
</script>
